import { css } from "@emotion/react";
import { Spacing } from "@snapchat/snap-design-system";
import { breakpointMap } from "shared-resources";

export const mainStyling = css`
    overflow: auto;
    height: 100%;
`;

export const sectionDropdown = css`
    @media (max-width: ${breakpointMap.sm}px) {
        display: flex;
        flex-direction: column;
        max-width: 70vw;
    }

    .ant-btn > span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const controlPadding = css`
    padding: 0 ${Spacing.MD}px ${Spacing.SM}px;
    @media (max-width: ${breakpointMap.sm}px) {
        padding: ${Spacing.SM}px 0;
    }
`;
